interface Ticket {
  ticketName: string;
  ticketCount: number;
}

function eposTwoColumn(columnOneText: string, columnTwoText: string) {
  return `<text>${columnOneText}</text>
  <text x="300" >${columnTwoText}&#10;</text>`;
}

function ticketsText(tickets: Ticket[]) {
  const texts = tickets.map(ticket => {
    return eposTwoColumn(ticket.ticketName + ' :', ticket.ticketCount + ' 枚');
  });
  return texts.join('\n');
}

export function eposPrint(
  planName: string,
  tickets: Ticket[],
  bookingId: string,
  accountName: string,
  issuedTime: string,
  reprint: boolean
) {
  const sumTickets = tickets.reduce((a, b) => a + b.ticketCount, 0);
  const appscheme = 'tmprintassistant://';
  const host = 'tmprintassistant.epson.com/';
  const action = 'print?';
  const xmlData = `<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">
  <text lang="ja"/>
  <text smooth="true" />
  <text font="font_a" />
  <text>商品名：${planName}&#10;</text>
  ${
    reprint
      ? `<text dw="true" dh="true" />
      <text>再発券 &#10;</text>
      <feed unit="5"/>
      <text dw="false" dh="false" />`
      : ''
  }
  ${ticketsText(tickets)}
  <text>------------------------------- &#10;</text>
  ${eposTwoColumn('合計：', sumTickets + ' 枚')}
  <feed line="1"/>
  <text>予約番号：&#10;</text>
  <text>${bookingId}&#10;</text>
  <feed line="1"/>
  <text>発券箇所：${accountName}&#10;</text>
  <feed line="1"/>
  <text>発券日時：${issuedTime}&#10;</text>
  <text>------------------------------- &#10;</text>
  <feed line="3"/>
  <cut type="feed"/>
  </epos-print>`;
  return `${appscheme}${host}${action}ver=1&data-type=eposprintxml&data=${encodeURIComponent(
    xmlData
  )}`;
  // return `${appscheme}${host}${action}success=${encodeURIComponent(
  //   window.location.href
  // )}&ver=1&data-type=eposprintxml&data=${encodeURIComponent(xmlData)}`;
}
